import { createReducerFromMap } from "@coverme/redux";

const initialState = {};

function updateFA(state, data) {
    return data.value;
}

function getInterview(state, action) {
    if (action.value.financialAssistance) {
        return updateFA(state, { value: action.value.financialAssistance });
    }

    return state;
}

function resetInterview(state, action) {
    return initialState;
}

export const financialAssistanceReducer = createReducerFromMap(initialState, {
    UPDATE_FINANCIAL_ASSISTANCE_COMPLETE: updateFA,
    GET_INTERVIEW_COMPLETE: getInterview,
    RESET_INTERVIEW: resetInterview,
});
